/**
 * セット販売（バンドル）セクション: 説明の続きを見る / アコーディオン内 Slick / Growave カウンター
 */
(function () {
  'use strict';

  if (window.__customBundleSaleJsBound) {
    return;
  }
  window.__customBundleSaleJsBound = true;

  var SEL = {
    root: '.custom-bundle-sale',
    readMore: '[data-description-read-more]',
    accordionDetails: '.custom-bundle-sale__accordion details',
    productList: '.product-list.custom-bundle-sale__product-list',
    accordionContent: '.accordion__content',
    openDetailsSliders:
      '.custom-bundle-sale__accordion details[open] .product-list.slick-initialized'
  };

  var SLIDER = {
    minContentWidth: 48,
    extraRefreshDelaysMs: [120, 350],
    fallbackDelayMs: 450,
    resizeDebounceMs: 150,
    breakpoints: { tablet: 901, mobile: 751 },
    slides: { desktop: 4, tablet: 3, mobile: 2 }
  };

  function initReadMore(root) {
    var more = root.getAttribute('data-read-more-label');
    var less = root.getAttribute('data-read-less-label');
    if (!more || !less) return;

    root.querySelectorAll(SEL.readMore).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrapper = btn.closest('[data-description-wrapper]');
        if (!wrapper) return;
        var expanded = wrapper.classList.toggle('is-description-expanded');
        btn.setAttribute('aria-expanded', expanded);
        btn.textContent = expanded ? less : more;
      });
    });
  }

  function initReadMoreAll() {
    document.querySelectorAll(SEL.root).forEach(initReadMore);
  }

  function createSliderController($) {
    function refresh($list) {
      if (!$list || !$list.length) return;
      if ($list.hasClass('slick-initialized')) {
        $list.slick('setPosition');
      }
    }

    function buildSlickOptions(slideCount) {
      function cap(n) {
        return Math.min(n, slideCount);
      }
      var d = cap(SLIDER.slides.desktop);
      var t = cap(SLIDER.slides.tablet);
      var m = cap(SLIDER.slides.mobile);

      return {
        slidesToShow: d,
        slidesToScroll: Math.min(1, d),
        infinite: slideCount > d,
        dots: false,
        focusOnSelect: slideCount > 1,
        responsive: [
          {
            breakpoint: SLIDER.breakpoints.tablet,
            settings: {
              slidesToShow: t,
              slidesToScroll: Math.min(3, t),
              infinite: slideCount > t
            }
          },
          {
            breakpoint: SLIDER.breakpoints.mobile,
            settings: {
              slidesToShow: m,
              slidesToScroll: Math.min(2, m),
              infinite: slideCount > m
            }
          }
        ]
      };
    }

    function initList($list) {
      if (!$list || !$list.length || $list.hasClass('slick-initialized')) return;

      var slideCount = $list.children().length;
      if (slideCount < 1) return;

      $list.off('init.bundleSlider').on('init.bundleSlider', function () {
        window.setTimeout(function () {
          refresh($list);
          $(window).trigger('resize');
        }, 0);
        window.setTimeout(function () {
          refresh($list);
        }, 100);
      });

      $list.slick(buildSlickOptions(slideCount));
    }

    function scheduleRefresh($list) {
      refresh($list);
      $(window).trigger('resize');
      SLIDER.extraRefreshDelaysMs.forEach(function (ms) {
        window.setTimeout(function () {
          refresh($list);
        }, ms);
      });
    }

    function tryInitOnce(details, $list) {
      if (!details.open || $list.hasClass('slick-initialized')) return;
      initList($list);
      if ($list.hasClass('slick-initialized')) {
        scheduleRefresh($list);
      }
    }

    function disconnectObserver(ref) {
      if (ref.observer) {
        ref.observer.disconnect();
        ref.observer = null;
      }
    }

    function attachAccordion(details, ref) {
      details.addEventListener('toggle', function () {
        var list = details.querySelector(SEL.productList);
        if (!list) return;
        var $list = $(list);
        var contentEl = details.querySelector(SEL.accordionContent);

        if (!details.open) {
          disconnectObserver(ref);
          if ($list.hasClass('slick-initialized')) {
            $list.slick('unslick');
          }
          return;
        }

        if (contentEl && typeof ResizeObserver !== 'undefined') {
          ref.observer = new ResizeObserver(function (entries) {
            if (!details.open) return;
            if ($list.hasClass('slick-initialized')) {
              disconnectObserver(ref);
              return;
            }
            if (entries[0].contentRect.width < SLIDER.minContentWidth) return;
            tryInitOnce(details, $list);
            disconnectObserver(ref);
          });
          ref.observer.observe(contentEl);
        }

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            tryInitOnce(details, $list);
          });
        });

        window.setTimeout(function () {
          if (!details.open) return;
          if (!$list.hasClass('slick-initialized')) {
            tryInitOnce(details, $list);
          } else {
            scheduleRefresh($list);
          }
        }, SLIDER.fallbackDelayMs);
      });
    }

    function bindWindowResize() {
      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          document.querySelectorAll(SEL.openDetailsSliders).forEach(function (el) {
            $(el).slick('setPosition');
          });
        }, SLIDER.resizeDebounceMs);
      });
    }

    return {
      bindAccordions: function () {
        document.querySelectorAll(SEL.accordionDetails).forEach(function (details) {
          attachAccordion(details, { observer: null });
        });
        bindWindowResize();
      }
    };
  }

  function initGrowaveWishlistCounter(root) {
    var fixed = false;
    var attempts = 0;
    var interval = window.setInterval(function () {
      if (++attempts > 30) {
        window.clearInterval(interval);
        return;
      }
      root.querySelectorAll('*').forEach(function (el) {
        if (!el.shadowRoot) return;
        el.shadowRoot.querySelectorAll('[class*="counter"]').forEach(function (counter) {
          counter.style.cssText += 'white-space:nowrap!important;width:max-content!important;';
          fixed = true;
        });
      });
      if (fixed) window.clearInterval(interval);
    }, 2000);
  }

  function run() {
    if (!document.querySelector(SEL.root)) return;

    initReadMoreAll();

    if (window.jQuery) {
      createSliderController(window.jQuery).bindAccordions();
    }

    document.querySelectorAll(SEL.root).forEach(initGrowaveWishlistCounter);
  }

  run();
})();
